import React from "react";
import { MyLeaveLeaveCardView } from "./leave-card-view";
import { useMyLeaveLeaveCard as useMyLeaveLeaveCardDI } from "./use-leave-card";
import { MyLeaveBarNewProps } from "my-leave/components";

export type MyLeaveLeaveCardProps = {
  type: "base" | "study" | "covid" | "eszjtv" | "emergency";
  useMyLeaveLeaveCard?: typeof useMyLeaveLeaveCardDI;
} & MyLeaveBarNewProps;

export const MyLeaveLeaveCard: React.FC<MyLeaveLeaveCardProps> = ({
  useMyLeaveLeaveCard = useMyLeaveLeaveCardDI,
  ...props
}: MyLeaveLeaveCardProps) => {
  const { title } = useMyLeaveLeaveCard(props);

  return <MyLeaveLeaveCardView {...props} label={title} />;
};
